import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { IChallengeTextDuration } from 'src/shared/models';
import { useWindowSize } from 'utils';

interface OwnProps {
  config: IChallengeTextDuration;
}

const ChallengeTextDuration: FC<OwnProps> = ({ config }) => {
  if (!config) return <React.Fragment />;
  const { isMD } = useWindowSize();
  const { title, content, contentIcon } = config;

  const classIcon = `icon--checkout-${contentIcon} text-duration-resource__content--icon `;

  return (
    <Row className="text-duration-resource__wrapper">
      <Col xs={24} className="text-duration-resource__content">
        <Row className="text-duration-resource__container">
          {contentIcon && (
            <Col>
              <div className={classIcon} />
            </Col>
          )}
          <Col>
            {title && (
              <h3 className="text-duration-resource__content--title">
                {title}
              </h3>
            )}
            <span
              className="text-duration-resource__content--wysiwyg"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ChallengeTextDuration;
